module.exports = __webpack_public_path__ + "media/images/logo-20926933257d9fef8848f1cf53e08ef9.png";